export const normalizeCustomerDomain = (domain?: string) => {
  return String(domain || '')
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, '')
    .replace(/^www\./, '')
    .split('/')[0];
};

export const isValidCustomerDomain = (domain?: string) => {
  return /^[a-z0-9.-]+\.[a-z]{2,}$/.test(normalizeCustomerDomain(domain));
};

export const customerLogoCandidates = (domain?: string, explicitLogoUrl?: string) => {
  const normalized = normalizeCustomerDomain(domain);
  const candidates = [
    explicitLogoUrl,
    normalized ? `https://www.google.com/s2/favicons?domain=${normalized}&sz=128` : '',
    normalized ? `https://icons.duckduckgo.com/ip3/${normalized}.ico` : '',
    normalized ? `https://logo.clearbit.com/${normalized}` : ''
  ].filter(Boolean) as string[];

  return Array.from(new Set(candidates));
};

export const customerInitials = (name?: string, domain?: string) => {
  const label = String(name || normalizeCustomerDomain(domain).split('.')[0] || 'Cloud')
    .replace(/[^a-zA-Z0-9\s-]/g, ' ')
    .trim();
  const parts = label.split(/[\s-]+/).filter(Boolean);
  const initials = parts.length > 1
    ? `${parts[0][0]}${parts[1][0]}`
    : label.slice(0, 2);

  return initials.toUpperCase();
};
